import { getDateTimeColumn, convertDate } from "./DateTimeValidation";

const hospitalOutWeekdaysDayTime = [
    {
        name: 'Weekdays Daytime Travel Premium',
        code: 'U960',
        price: 36.4,
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason = 'Physician did not perform travel.';
                return;
            }
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (code == 'U960') occurences++;
                })
            })
            if (occurences >= 2) {
                self.applicable = false;
                self.reason = 'Travel Premium used too many times';
                return;
            }
            self.applicable = true;
            self.reason = '';
        },
    },
    {
        code: 'U990',
        name: 'First Person Seen Weekdays Daytime',
        price: 20,
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason += 'Not first person seen.\n';
                return;
            }
            const codesThatCount = ['U990', 'U991'];
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 10) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }
    },
    {
        code: 'U991',
        price: 20,
        name: 'Additional Person(s) seen Weekdays Daytime',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason += 'An additonal person seen.\n';
                return;
            }
            const codesThatCount = ['U990', 'U991'];
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 10) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }
    }
];

const hospitalOutWeekdaysDaytimeSacrifice = [
    {
        name: 'Travel Premium Weekdays Daytime Sacrifice of Hours',
        code: 'U961',
        applicable: false,
        price: 36.4,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Physician did not perform travel\n';
                return;
            }
            const codesThatCount = ['U961'];
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 2) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }
    },
    {
        code: 'U992',
        price: 40,
        reason: '',
        name: 'Weekdays Daytime First Person Seen Sacrifice of Hours',
        applicable: false,
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason += 'Not first person seen.\n';
                return;
            }
            const codesThatCount = ['U992', 'U993'];
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 10) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }
    },
    {
        name: 'Additional Person(s)  Weekdays Daytime Sacrifice of Hours',
        price: 40,
        reason: '',
        applicable: false,
        code: 'U993',
        validate({ self, newApt, timePeriodAppointments }) {
            if (newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason += 'Not additonal person(s) seen.\n';
                return;
            }
            const codesThatCount = ['U992', 'U993'];
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 10) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }
    }
];

const hospitalOutWeekdayEvenings = [
    {
        name: 'Travel Premium Weekdays Evenings',
        price: 20,
        code: 'U962',
        reason: '',
        applicable: false,
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Physicain did not travel.\n';
                return;
            }
            const codesThatCount = ['U962'];
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 2) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }
    },
    {
        code: 'U994',
        price: 60,
        applicable: false,
        reason: '',
        name: 'First Person Seen Evenings',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason += 'Not first person seen.\n';
                return;
            }
            const codesThatCount = ['U994', 'U995'];
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 10) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }
    },
    {
        name: 'Additional Person(s) seen Evenings',
        price: 60,
        code: 'U995',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason += 'Not additional person seen.\n';
                return;
            }
            const codesThatCount = ['U994', 'U995'];
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 10) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }
    },
];

const hospitalOutWeekendsAndHolidays = [
    {
        name: 'Travel Premium Weekends/Holidays',
        code: 'U963',
        price: 36.4,
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.performedTravel) {
                self.applicable = false;
                self.reason += 'Physician did not travel.\n';
                return;
            }
            const codesThatCount = ['U963'];
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 6) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }
    },
    {
        name: 'First Person Seen Weekends/Holidays',
        price: 75,
        code: 'U998',
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (!newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason += 'Not first person seen.\n';
                return;
            }
            const codesThatCount = ['U994', 'U995'];
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 20) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }
    },
    {
        name: 'Additional Person Seen Weekends/Holidays',
        code: 'U999',
        price: 75,
        applicable: false,
        reason: '',
        validate({ self, newApt, timePeriodAppointments }) {
            if (newApt.firstPersonSeen) {
                self.applicable = false;
                self.reason += 'Not additonal person seen.\n';
                return;
            }
            const codesThatCount = ['U998', 'U999'];
            let occurences = 0;
            timePeriodAppointments.forEach(apt => {
                apt.codes.forEach(code => {
                    if (codesThatCount.includes(code)) occurences++;
                })
            })
            if (occurences >= 20) {
                self.applicable = false;
                self.reason += 'Maximum billing per cycle reached.';
                return;
            }
            self.applicable = true;
            self.reason = '';
        }
    }
];

const nights = [
    {
        name:' Travel Premium Nights',
        code:'U964',
        price:36.4,
        applicable: false,
        reason:'',
        validate({self, newApt, timePeriodAppointments}){
            if(newApt.performedTravel){
                self.applicable = false;
                self.reason += 'Physician did not travel.\n';
                return;
            }
            self.applicable = true;
            self.reason ='';
        }
    },
    {
        name: 'First Person Seen Nights',
        code: 'U996',
        price:100,
        applicable:false,
        reason:'',
        validate({self, newApt, timePeriodAppointments}){
            if(newApt.firstPersonSeen){
                self.applicable = false;
                self.reason += 'Patient is not first seen.\n';
                return;
            }
            self.applicable = true;
            self.reason ='';
        }

    },
    {
        name: 'Additonal Person Seen Nights',
        code: 'U997',
        price:100,
        applicable:false,
        reason:'',
        validate({self, newApt, timePeriodAppointments}){
            if(!newApt.firstPersonSeen){
                self.applicable = false;
                self.reason += 'Patient is not additonally seen.\n';
                return;
            }
            self.applicable = true;
            self.reason ='';
        }

    }
]





export function getHospitalOutPatientDepartmentColumn(newApt) {
    const dateObject = convertDate(newApt.date, newApt.time);
    const columnType = getDateTimeColumn(dateObject);

    // ['weekdaysDaytime','weekdaysEvening', 'nights', 'weekendOrHoliday']
    switch (columnType) { // NEED TO UPDATE FROM EMERG
        case 'weekdaysDaytime':
            if (newApt.sacrificeOfOfficeHours) return hospitalOutWeekdaysDaytimeSacrifice;
            else return hospitalOutWeekdaysDayTime;
        case 'weekdaysEvening':
            return hospitalOutWeekdayEvenings;
        case 'nights':
            return nights;
        case 'weekendOrHoliday':
            return hospitalOutWeekendsAndHolidays;
    }
}